import React from 'react'
import { Box } from '@mui/material'
import { badgePalette } from './intelTheme'

export default function Badge({ children, color = 'grey', sx = {} }) {
  const palette = badgePalette[color] || badgePalette.grey
  return (
    <Box
      component='span'
      sx={{
        background: palette.bg,
        color: palette.color,
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: 10,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        display: 'inline-block',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
